export default {
  FULL: "Full",
  PART: "Part",
  NONE: "None",
};
